import { Flame, Clock } from 'lucide-react';

/**
 * Subtle urgency banner shown above slot pickers when a day is filling up.
 * Tuned to be informative without feeling spammy.
 *
 *   available  ≤ 2  → "Plus que X créneaux"  (red, fire icon)
 *   available  ≤ 5  → "Se remplit vite"      (amber, clock icon)
 *   otherwise       → renders nothing
 */
export default function UrgencyBadge({ available, total, className = '' }) {
  if (available == null) return null;
  // No urgency if plenty of slots — keep the UI clean
  if (available > 5 || available <= 0) return null;

  const isCritical = available <= 2;

  const Icon = isCritical ? Flame : Clock;
  const color = isCritical
    ? 'bg-red-50 text-red-700 border-red-200'
    : 'bg-amber-50 text-amber-800 border-amber-200';

  const label = isCritical
    ? (available === 1
        ? 'Dernier créneau disponible — réservez vite !'
        : `Plus que ${available} créneaux disponibles`)
    : 'Cette date se remplit vite';

  return (
    <div
      className={`flex items-center gap-2 px-3 py-2 rounded-lg border text-xs font-medium ${color} ${className}`}
      data-testid={`urgency-${isCritical ? 'critical' : 'warning'}`}
    >
      <Icon className="w-3.5 h-3.5 flex-shrink-0" />
      <span>{label}</span>
      {total != null && total > 0 && (
        <span className="ml-auto opacity-70">{available}/{total}</span>
      )}
    </div>
  );
}
